import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/ui/section';
import CTA from 'react-scale/components/ui/cta';

const SimpleCentered = ({ theme, title, cta, border, themeColors }) => (
  <div className={cn({ 'border-t': border }, borderTheme[theme])}>
    <Section bg={cn(bgTheme[theme])} center container={false}>
      <div className="container flex flex-col items-center justify-center">
        <h2 className={cn('mb-10 font-aeonik text-3xl', themeColors?.textColor || 'text-gradient')}>
          {title}
        </h2>
        <div className="flex">
          <CTA theme={theme} cta={cta} themeColors={themeColors?.buttons} />
        </div>
      </div>
    </Section>
  </div>
);

const borderTheme = {
  dark: 'border-gray-800',
  light: 'border-gray-200'
};

const bgTheme = {
  dark: 'bg-black border-neutral-800',
  light: 'bg-transparent border-gray-200'
};

SimpleCentered.defaultProps = {
  theme: 'dark',
  themeColors: undefined,
  title: 'Get Started Today',
  border: false,
  cta: undefined
};

export default SimpleCentered;
